<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <div class="mt-4">
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="black"
        style="background: transparent"
      >
        <v-tab>{{ $t('printer') }}</v-tab>
        <v-tab>{{ $t('PrintGroupManagement') }}</v-tab>
        <v-tab>{{ $t('printTemplate') }}</v-tab>
        <v-tab>{{ $t('FreeInformationBon') }}</v-tab>
      </v-tabs>
      <v-divider />
    </div>
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <v-tab-item>
        <section-printer-setting />
      </v-tab-item>
      <v-tab-item>
        <print-group />
      </v-tab-item>
      <v-tab-item>
        <bon-template />
      </v-tab-item>
      <v-tab-item>
        <free-info-sheet-vue />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import SectionPrinterSetting from '@/views/AadenPages/print/SectionPrinterSetting'
import BonTemplate from '@/views/AadenPages/print/BonTemplate'
import FreeInfoSheetVue from '@/views/AadenPages/settings/FreeInfoSheet'
import PrintGroup from '@/views/AadenPages/print/PrintGroup'

export default {
  name: 'PrintIndex',
  components: {
    PrintGroup,
    FreeInfoSheetVue,
    BonTemplate,

    SectionPrinterSetting

  },
  data () {
    return {
      tab: null
    }
  }
}
</script>

<style scoped>

</style>
